<template>
  <div class="Select">
    <select
      :id="id"
      class="Select-ctrl"
      :class="{'Select-ctrl--table' : tableLayout}"
      @input="emitValue"
      :disabled="disabled"
    >
      <option
        :selected="selectedValueToShow(item)"
        :class="{'selected' : item && item.id ? selectedValue === item.id : selectedValue === item}"
        v-for="(item,index) in dataCollection"
        :value="item && item.id ? item.id : item"
        :key="`sel-${index}`"
      >{{ignoreItemTranslation ? setItemLabel(item) : $t(setItemLabel(item))}} <template v-if="additionalInfo">{{setItemLabel(item[additionalInfoKey])}}</template></option>
    </select>
    <span class="Select-icon ">
      <svg
        focusable="false"
        aria-hidden="true"
        aria-label="Edit"
      >
        <use xlink:href="#dropdown-icon"></use>
      </svg></span>
    <!-- ************ DROPDOWN *************** -->
    <symbol
      id="dropdown-icon"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
    >
      <g
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="element/icon/16/down"
          stroke="#5E6D7C"
        >
          <polyline
            id="Path-2"
            points="4 6 8 10 12 6"
          ></polyline>
        </g>
      </g>
    </symbol>

  </div>
</template>

<script>
export default {
  name: 'InputSelect',
  props: {
    id: [Number, String],
    value: [Number, String],
    dataCollection: {
      type: Array,
      required: true
    },
    additionalInfo: {
      type: Boolean
    },
    additionalInfoKey: {
      type: String
    },
    placeholder: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String
    },
    defaultSelected: {
      type: [Number, String]
    },
    tableLayout: {
      type: Boolean
    },
    label: {
      type: String
    },
    ignoreItemTranslation: {
      type: Boolean,
      default: false
    },
    fieldForDefaultSelected: {
      type: String
    },
    emitFullValue: {
      type: Boolean
    }
  },
  methods: {
    emitValue (v) {
      if (!v.target.value) return
      if (this.emitFullValue) {
        let id = this.dataCollection.find(el => el.id === Number.parseInt(v.target.value))

        if (id) {
          this.$emit('input', id)
        }
      } else {
        this.$emit('input', v)
      }
    },
    setItemLabel (item) {
      if (this.label) {
        return item && item[this.label] ? item[this.label] : item
      }
      return item && item.name ? item.name : item
    },
    selectedValueToShow (item) {
      if (item && item.id) {
        if (this.selectedValue && this.fieldForDefaultSelected) {
          return this.selectedValue === item[this.fieldForDefaultSelected]
        } else {
          return this.selectedValue === item.id
        }
      }
    }

  },
  computed: {
    selectedValue () {
      if (this.defaultSelected && !this.value) {
        return this.defaultSelected
      } else if (this.defaultSelected === undefined) {
        return undefined
      } else {
        return this.value
      }
    }

  },
  created () {
    if (this.defaultSelected && !this.value) {
      let selected = {}
      /// TODO: This needs to be fixed
      if (this.fieldForDefaultSelected) {
        selected = this.dataCollection.find(el => el[this.fieldForDefaultSelected] === this.defaultSelected)
      } else {
        selected = this.dataCollection.find(el => {
          if (el && el.id) {
            return el.id === this.defaultSelected
          } else {
            return el === this.defaultSelected
          }
        })
      }
      this.$emit('input', selected)
    }
  }

}
</script>
